import React, { useState, useEffect } from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import AlertCircleOutline from 'mdi-react/AlertCircleOutlineIcon';
import { Select } from '../Forms';
import { LocationDto, LocationService } from '../../../entities/Location';

type Props = {
  values: any;
};

const DepartureUnloadingData: React.FC<Props> = ({ values }) => {
  const { unloadingLocationConfiguration } = values;

  const [locationConfigs, setLocationConfigs] = useState([{ name: '', isModyfied: false }]);

  const [isWarnings, setIsWarning] = useState(false);

  useEffect(() => {
    const branchLocal = localStorage.getItem('branchId') || 'null';
    const branchId = JSON.parse(branchLocal)?.id;
    LocationService.getLocations({ params: { branchId } }).then((res: LocationDto[]) => {
      const configs = res
        .filter((x) => x.isDeleted === false)
        .flatMap(({ configurations, name }) =>
          configurations
            .filter((x) => x.isDeleted === false)
            .map((c) => {
              const fn = `${name}; ${c.name}`;
              return { name: fn, isModyfied: false };
            }),
        );
      if (
        configs &&
        unloadingLocationConfiguration &&
        configs.filter((x) => x.name === unloadingLocationConfiguration).length === 0
      ) {
        configs.push({ name: unloadingLocationConfiguration, isModyfied: true });
        setIsWarning(true);
      }
      setLocationConfigs(configs);
    });
  }, []);

  return (
    <Card className="mb-3">
      <Card.Header className="d-flex py-0">
        {isWarnings && (
          <span className="d-flex align-items-center justify-content-center">
            <AlertCircleOutline size={15} />
          </span>
        )}
        <span className="d-block font-weight-bolder ml-4 mr-5 py-1">Дані в’їзду</span>
      </Card.Header>

      <Card.Body>
        <Row>
          <Col>
            <Select
              name="unloadingLocationConfiguration"
              label="Місце розвантаження"
              onChange={(event) => {
                const modifyed = locationConfigs?.filter((x) => x.isModyfied)?.[0];
                if (modifyed && modifyed.name === event.target.value) {
                  setIsWarning(true);
                } else {
                  setIsWarning(false);
                }
              }}
            >
              {locationConfigs.map((x) => (
                <option value={x.name}>
                  {x.name} {x.isModyfied ? ' (видалено або змінено)' : ''}
                </option>
              ))}
            </Select>
          </Col>
          <Col>&nbsp;</Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default DepartureUnloadingData;
